var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.konvertNumber)?_c('alert',{attrs:{"alert-type":"success"}},[_c('p',{staticClass:"mb-0"},[_vm._v("Конверт принят под номером: "+_vm._s(_vm.konvertNumber))]),_c('p',[_vm._v("Дата принятия: "+_vm._s(_vm.dateKonvert))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }